import type { FC } from 'react'

import type { MdiReactIconComponentType } from 'mdi-react'

import { useAppContext } from '@/App.context'

import './button.scss'

const Button: FC<{
  className?: string
  Icon?: MdiReactIconComponentType
  selected?: boolean
  [k: string]: any
}> = ({ className = '', Icon, children, selected = false, ...restOfProps }) => {
  const { whiteLabel } = useAppContext()

  return (
    <button
      className={`button ${Icon && 'with-icon'} ${className} wl-${whiteLabel} ${
        selected && 'selected'
      }`}
      {...restOfProps}
    >
      {Icon && <Icon />}

      {children}
    </button>
  )
}

export default Button
